import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-district-cancer-control-programme',
  templateUrl: './district-cancer-control-programme.component.html',
  styleUrls: ['./district-cancer-control-programme.component.css']
})
export class DistrictCancerControlProgrammeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.documentElement.scrollTop = 0;
  }

}
